import React from 'react';
import { CheckboxV2, CheckboxV2Props, styled } from '@withjoy/joykit';
import { OVERRIDE_HOVER_STYLES, controlStyles } from '@shared/createEvent/formElements/formElements.styles';

const StyledEventCheckboxV2InputV2 = styled(CheckboxV2)`
  ${OVERRIDE_HOVER_STYLES};
`;

const EventCheckboxV2 = React.forwardRef<HTMLInputElement, CheckboxV2Props>((props, ref) => {
  return <StyledEventCheckboxV2InputV2 ref={ref} {...props} fontWeight={400} color="mono5" />;
});

EventCheckboxV2.defaultProps = {
  overrides: {
    Control: {
      props: controlStyles
    }
  }
};

export { EventCheckboxV2 };
